export const common = {
  // Navigation
  home: "INÍCIO",
  narrative: "FICÇÃO",
  commercial: "COMERCIAL / VIDEOCLIPES",
  doc: "DOC", 
  reel: "ROLO",
  bio: "BIO",
  contact: "CONTATO",
  
  // Header
  cinematographer: "DIRETOR DE FOTOGRAFIA & OPERADOR DE GIMBAL",
  
  // Footer
  allRightsReserved: "Todos os direitos reservados",
  
  // Contact
  getInTouch: "ENTRE EM CONTATO",
  name: "Nome",
  email: "Email",
  message: "Mensagem", 
  send: "ENVIAR",
  
  // Language
  language: "Idioma",
  english: "English",
  portuguese: "Português",
  
  // Doc page
  docDescription: "Capturando histórias autênticas e momentos reais através da cinematografia documental. Cada projeto representa um compromisso com a narrativa verdadeira e excelência visual.",
  
  // Project titles
  evidenciasDoAmor: "EVIDÊNCIAS DO AMOR",
  benzinho: "BENZINHO",
  aWolfAmongSwans: "UM LOBO ENTRE CISNES",
  techBrandCampaign: "ASPIRANTES",
  osUltimosDiasDeGilda: "OS ÚLTIMOS DIAS DE GILDA",
  
  // Project descriptions
  benzinhoDesc: "Longa-Metragem / Ficção\nDireção de Gustavo Pizzi",
  evidenciasDoAmorDesc: "Longa-Metragem / Ficção\nDireção de Pedro Antônio Paes",
  aWolfAmongSwansDesc: "Longa-Metragem / Ficção\nDireção de Helena Varvaki e Marcos Schechtman",
  agentesMuitoEspeciaisDesc: "Longa-Metragem / Direção de Pedro Antônio Paes e Zaga Marteletto",
  mallandroDesc: "Longa-Metragem / Ficção\nDireção de Marco Antônio de Carvalho",
  doceFamiliaDesc: "Longa-Metragem / Ficção\nDireção de Carol Durão",
  hopefulsDesc: "Longa-Metragem / Ficção  Direção de Ives Rosenfeld",
  osUltimosDiasDeGildaDesc: "Minissérie / Ficção\nDireção de Gustavo Pizzi",
  jorgeOfCapadociaDesc: "Longa-Metragem / Ficção\nDireção de Alexandre Machafer",
  esseAmorQueNosConsomeDesc: "Longa-Metragem / Ficção/Doc  Direção de Allan Ribeiro",
  rensgaHitsDesc: "Série / Ficção  Direção de Carol Durão, Bella Gabaglia e Natalia Warth",
  fernandoDesc: "Longa-Metragem / Doc/Ficção  Direção de Paula Vilela, Juaar e Igor Angelkort",
  xandAviaoDesc: "Videoclipe / Direção de Rodrigo Van der Put e Bruno Duarte",
  biltreDesc: "Videoclipe / Direção de Anna Costa",
  juanMarcusDesc: "Videoclipe / Direção de Rodrigo Van der Put e Bruno Duarte",
  leoSantanaDesc: "Videoclipe / Direção de Rodrigo Van der Put e Bruno Duarte",
  porUmRespiroDesc: "Série / Doc  Direção de Susanna Lira e Helena de Castro",
  nosDocumentaristasDesc: "Série / Doc / Direção de Susanna Lira",
  damasDoSambaDesc: "Longa-Metragem / Doc  Direção de Susanna Lira",
  faustoFawcettDesc: "Longa-Metragem / Doc\nDireção de Vitor Lopes",
  perfectStormDesc: "Longa-Metragem / Doc  Direção de Gustavo Malheiros",
  outrosTemposDesc: "Série / Doc  Direção de Susanna Lira",
  
  // Bio content
  bioContent: `Pedro Faerstein é diretor de fotografia e operador de gimbal com mais de duas décadas de experiência no audiovisual. Nascido no Rio, frequentou o Colégio da Aplicação da UERJ, onde teve suas primeiras aulas de fotografia com o professor Paulo Rodrigues. Depois de uma breve passagem pelo curso de direito da UERJ, Pedro cedeu à sua paixão pelo cinema e ingressou na UFF, onde focou os estudos na fotografia para cinema.

Ao longo dos últimos anos, Pedro acumulou um portfólio diversificado, atuando como diretor de fotografia em filmes de curta e longa metragem, documentários, ficção televisiva, comerciais, videoclipes e projetos institucionais. Destacam-se, entre seus trabalhos, os seguintes longas-metragens:

* "Positivas" (Susanna Lira, 2009)
* "Esse Amor que nos Consome" (Allan Ribeiro, 2012)
* "Damas do Samba" (Susanna Lira, 2013)
* "Aspirantes" (Ives Rosenfeld, 2015)
* "Fernando" (Igor Angelkorte, Paula Vilela e Ju Ariani, 2016)
* "Benzinho" (Gustavo Pizzi, 2016)
* "Jorge da Capadócia" (Alexandre Machafer, 2019)
* "Tempestade Perfeita" (Gustavo Malheiros, 2021)
* "Fausto Fawcett na Cabeça" (Vitor Lopes, 2021)
* "Doce Familia" (Carol Durão, 2022)
* "Mallandro, o Errado que deu Certo" (Marco Antônio de Carvalho, 2022)
* "Um Lobo entre Cisnes" (Marcos Schettmann e Helena Varvaki, 2023)
* "Evidências do Amor" (Pedro Antônio Paes, 2023)
* "Gambiarra, Uga Uga Show" (Gustavo Colombo, 2024)
* "Mamãe Saiu de Férias" (Carol Durão, 2024)
* "Jeff e Johnny" (Pedro Antônio Paes, 2024)

Para TV, fez a direção de fotografia de diversas séries, tais como:

* "Em busca do Pai" (GNT, 2012)
* "Meus Dias de Rock" (Canal Brasil, 2013)
* "Anônimos Famosos" (Cine Brasil TV, 2014)
* "Outros Tempos" (HBO, 2016)
* "Prêmio Multishow de Humor" (2016)
* "Que Marravilha" (GNT, 2017)
* "Os Últimos Dias de Gilda" (Gustavo Pizzi, Canal Brasil, 2018)
* "SuperBonita" (GNT, 2019)
* "Por um Respiro" (Globoplay, 2020)
* "O tempo que a gente tem" (GNT, 2021)
* "Rensga Hits" (Globoplay, 2ª e 3ª Temporada, 2024)`
};

export default common;
